<div class="h-100 w-100 min-width overflow-hidden p-3">
	<router-outlet></router-outlet>
</div>